export const range = (lower: number, upper: number): number[] =>
    Array.from({length: upper - lower}, (_, i) => lower + i);

/**
 * Generate a range of numbers separated by the given step.
 *
 * @param lower Lower bound
 * @param upper Upper bound
 * @param step Range step
 * @param includeUpper Whether to include the given upper bound. Defaults to false
 */
export const rangeWithStep = (lower: number, upper: number, step: number, includeUpper?: boolean): number[] => {
    const _upper = includeUpper ? upper + 1 : upper;
    const length = Math.ceil((_upper - lower) / step);

    return Array.from({length}, (_, i) => lower + i * step);
};
